<template>
  <div class="container">
    <!-- 顶部大图 -->
    <!-- <div ata-wow-delay="0.2s" class="wow fadeInUp">132456</div> -->
    <div class="banner">
      <div class="main">
        <div class="wow fadeInUp" ata-wow-delay="0.2s">
          <div class="ban_title">定制软件开发·移动应用开发</div>
          <div class="ban_content">我们为各行业提供创新，高效的技术解决方案，助力企业实现数字化转型。</div>
        </div>
      </div>
    </div>
    <!-- 我们的业务 -->
    <div class="out_business">
      <div class="business">
        <div class="title wow fadeInUp" ata-wow-delay="0.2s">我们的业务</div>
        <div class="business_main">
          <div class="business_main_item wow fadeInLeft" ata-wow-delay="0.2s">
            <img src="../../assets/image/appkf.png" alt="">
            <div class="sub_title">APP开发</div>
            <div class="sub_content">
              量身定制iOS和Android 应用，确保高效性能和优 质用户体验。
            </div>
          </div>
          <div class="business_main_item wow fadeInLeft" ata-wow-delay="0.2s">
            <img src="../../assets/image/xcxkf.png" alt="">
            <div class="sub_title">小程序开发</div>
            <div class="sub_content">
              专注于微信平台，开发功 能丰富的小程序，增强用 户互动和业务效率。
            </div>
          </div>
          <div class="business_main_item wow fadeInRight" ata-wow-delay="0.2s">
            <img src="../../assets/image/Group 110.png" alt="">
            <div class="sub_title">物联网软件开发</div>
            <div class="sub_content">
              开发智能设备管理和数据 分析软件，助力物联网解 决方案。
            </div>
          </div>
          <div class="business_main_item wow fadeInRight" ata-wow-delay="0.2s">
            <img src="../../assets/image/Group 114.png" alt="">
            <div class="sub_title">网站系统开发</div>
            <div class="sub_content">
              设计和开发高效的网站和 系统，提升您的在线业务 表现和用户体验。
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 开发流程 -->
    <div class="procedure">
      <div class="procedure_content">
        <div class="title wow fadeInUp" ata-wow-delay="0.2s">开发流程</div>
        <div class="procedure_item p1 wow fadeInUp" ata-wow-delay="0.2s">
          <div>需求分析</div>
          <div>我们与客户进行深入沟通，全面 理解业务需求、目标和预期成果， 确保开发方向与客户愿景一致。</div>
        </div>
        <div class="procedure_item p2 wow fadeInUp" ata-wow-delay="0.2s">
          <div>规划与设计</div>
          <div>基于需求，我们制定详细的项目 计划和时间表。我们的设计团队 会创建系统架构和用户界面原型， 确保设计符合您的期望。</div>
        </div>
        <div class="procedure_item p3 wow fadeInUp" ata-wow-delay="0.2s">
          <div>定制开发</div>
          <div>在设计确认后，我们的开发团队 开始编码和实现功能。采用敏捷 开发方法，确保在每个阶段都能 交付可用的功能。</div>
        </div>
        <div class="procedure_item p4 wow fadeInUp" ata-wow-delay="0.2s">
          <div>部署与上线</div>
          <div>我们协助客户进行系统部署，确 保软件在生产环境中的稳定运行， 并提供上线支持。</div>
        </div>
        <div class="procedure_item p5 wow fadeInUp" ata-wow-delay="0.2s">
          <div>测试</div>
          <div>我们进行全面的测试，包括功能 测试、性能测试和用户验收测试， 我们确保软件的稳定性、可用性 和安全性。</div>
        </div>
        <div class="procedure_item p6 wow fadeInUp" ata-wow-delay="0.2s">
          <div>用户培训与文档</div>
          <div>为客户提供全面的用户培训和详 细的项目文档，包括用户手册和 API文档，以促进软件的快速采纳 和使用。</div>
        </div>
        <div class="procedure_item p7 wow fadeInUp" ata-wow-delay="0.2s">
          <div>维护与支持</div>
          <div>上线后，我们提供持续的维护和 技术支持。我们监控系统性能， 及时处理问题，并进行系统优化， 确保您的软件始终稳定运行。</div>
        </div>
        <div class="procedure_item p8 wow fadeInUp" ata-wow-delay="0.2s">
          <div>优化</div>
          <div>我们持续关注用户反馈和业务变 化，提供必要的功能扩展和系统 优化，帮助您的软件适应不断变 化的需求。</div>
        </div>
      </div>
    </div>
    <!-- 我们的优势 -->
    <div class="advantage">
      <img src="../../assets/image/wmdys_bg.png" class="bg_img">
      <div class="advantage_content">
        <div class="title">我们的优势</div>
        <div class="advantage_content_list">
          <div class="advantage_content_list_item wow fadeInUp" ata-wow-delay="0.2s" v-for="(item, index) in advantageList" :key="index">
            <img :src="require(`@/assets/image/${item.path}`)">
            <div>
              <div class="sub_title">{{ item.title }}</div>
              <div>
                {{ item.content }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 软件开发应用行业 -->
    <div class="industry">
      <div class="industry_content">
        <div class="title">软件开发应用行业</div>
        <div class="industry_content_list">
          <div class="industry_content_list_item i1 wow fadeInUp" ata-wow-delay="0.2s">
            金融行业
          </div>
          <div class="industry_content_list_item i2 wow fadeInUp" ata-wow-delay="0.2s">
            智慧医疗
          </div>
          <div class="industry_content_list_item i3 wow fadeInUp" ata-wow-delay="0.2s">
            教育培训
          </div>
          <div class="industry_content_list_item i4 wow fadeInUp" ata-wow-delay="0.2s">
            制造与零售
          </div>
          <div class="industry_content_list_item i5 wow fadeInUp" ata-wow-delay="0.2s">
            生活服务
          </div>
          <div class="industry_content_list_item i6 wow fadeInUp" ata-wow-delay="0.2s">
            能源物流
          </div>
          <div class="industry_content_list_item i7 wow fadeInUp" ata-wow-delay="0.2s">
            政府与公共部门
          </div>
          <div class="industry_content_list_item i8 wow fadeInUp" ata-wow-delay="0.2s">
            房地产
          </div>
          <div class="industry_content_list_item i9 wow fadeInUp" ata-wow-delay="0.2s">
            企业办公
          </div>
          <div class="industry_content_list_item i10 wow fadeInUp" ata-wow-delay="0.2s">
            社交直播
          </div>
          <div class="industry_content_list_item i11 wow fadeInUp" ata-wow-delay="0.2s">
            旅游
          </div>
          <div class="industry_content_list_item i12 wow fadeInUp" ata-wow-delay="0.2s">
            智慧城市
          </div>
        </div>
      </div>
    </div>

  </div>
</template>
<script>

export default {
  data() {
    return {
      currentType: null,
      showMask: false,
      androidPath: null,
      iosPath: null,
      advantageList: [
        { title: '专业团队',content: '我们拥有经验丰富的开发工程师、设计 师和项目经理，为您提供定制化的高质 量解决方案，确保项目成功交付。',path: 'zytd.png' },
        { title: '安全可靠',content: '我们严格遵守行业安全标准，确保所 有软件产品都具有高安全性和数据保 护能力。',path: 'aqkk.png' },
        { title: '先进技术',content: '我们采用最新技术和工具， 确保您的软 件高效、可靠且可扩展。无论是Web应 用还是移动应用， 我们都能提供前沿技 术支持。',path: 'xjjs.png' },
        { title: '高效流程',content: '我们优化的开发流程确保按时、按预算 交付项目。通过严格的测试和持续支持， 我们保证软件的高质量和性能。',path: 'gxlc.png' },
        { title: '价格优势',content: '我们提供具有竞争力的定价方案，以高 性价比的服务帮助您有效控制成本，同 时获得优质的软件解决方案。',path: 'jgys.png' },
        { title: '灵活性',content: '我们能快速适应需求变化和市场条件， 确保项目始终符合最新的业务要求和 市场趋势。',path: 'lhx.png' },
      ],
    };
  },
  mounted() {
    var wow = new this.$wow.WOW({
      boxClass: 'wow',
      animateClass: 'animated',
      offset: 0,
      mobile: true,
      live: true
    });
    wow.init();
  }
};
</script>
<style scoped lang="scss">
$width: 1200px;
.container {
  width: 100vw;
  height: auto;
  background: #f8f8f8;
  .title {
    width: 100%;
    font-size: 30px;
    color: #333333;
    font-weight: bold;
    margin: 0 0 85px 0;
    padding-top: 85px;
    box-sizing: border-box;
    text-align: center;
    position: relative;
    &::after {
      content: '';
      width: 50px;
      height: 6px;
      background: #3C6AFD;
      position: absolute;
      left: 50%;
      bottom: -45px;
      transform: translateX(-50%);
    }
  }
  .banner {
    width: 100%;
    height: 550px;
    background: url('../../assets/image/sy_banner.png');
    background-repeat: no-repeat;
		background-size: 100% auto;
    .main {
      width: $width;
      margin: 0 auto;
      padding-top: 220px;
      box-sizing: border-box;
      color: #222;
      .ban_title {
        font-size: 46px;
        font-weight: bold;
      }
      .ban_content {
        font-size: 16px;
        margin-top: 10px;
      }
    }
  }
  .out_business {
    width: 100%;
    background: url('../../assets/image/wmdyw_bg.png');
    background-repeat: no-repeat;
		background-size: 100% auto;
    .business {
      width: $width;
      margin: 0 auto;
      &_main {
        display: flex;
        column-gap: 52px;
        padding-bottom: 76px;
        display: grid;
        grid-template-columns: repeat(4, 1fr);
        grid-gap: 20px;
        &_item {
          background: #fff;
          border-radius: 50px 10px 50px 10px;
          padding: 50px 50px 75px 50px;
          box-sizing: border-box;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          transition: all 0.3s ease;
          img {
            width: 70px;
            height: 70px;
          }
          .sub_title {
            margin: 20px 0 16px 0;
            font-size: 20px;
            color: #333333;
            font-weight: bold;
          }
          .sub_content {
            color: #666666;
            font-size: 16px;
          }
        }
        &_item:hover {
          box-shadow: 0 5px 30px rgba(0, 0, 0, .1);
        }
      }
    }
  }
  .procedure {
    width: 100%;
    height: 1100px;
    background: url('../../assets/image/kflc_bg.png');
    background-repeat: no-repeat;
		background-size: 100% auto;
    &_content {
      width: $width;
      margin: 0 auto;
      position: relative;
      .procedure_item {
        width: 280px;
        height: 174px;
        background: #3C6AFD;
        border-radius: 20px 20px 20px 20px;
        padding: 24px 18px;
        box-sizing: border-box;
        background: #fff;
        display: flex;
        flex-direction: column;
        row-gap: 16px;
        align-items: center;
        font-size: 16px;
        position: absolute;
        transition: all 0.3s ease;
        & > div:first-child {
          font-size: 20px;
          font-weight: bold;
        }
      }
      .procedure_item:hover {
        box-shadow: 0 5px 30px rgba(0, 0, 0, .1);
      }
      .p1 {
        background: #3C6AFD!important;
        color: #fff!important;
        top: 280px;
        left: 0px;
      }
      .p2{
        top: 280px;
        left: 358px;
      }
      .p3{
        top: 280px;
        left: 716px;
      }
      .p4{
        top: 560px;
        left: 671px;
      }
      .p5{
        top: 560px;
        left: 241px;
      }
      .p6{
        top: 840px;
        left: 204px;
      }
      .p7{
        top: 840px;
        left: 562px;
      }
      .p8{
        top: 840px;
        left: 916px;
      }
    }
  }
  .advantage {
    width: 100%;
    height: 713px;
    background: #F8F8F8;
    position: relative;
    .bg_img {
      width: 598px;
      height: 517px;
      position: absolute;
      left: 0px;
      bottom: 0px;
    }
    &_content {
      width: $width;
      margin: 0 auto;
      position: relative;
      &_list {
        display: grid;
        grid-template-columns: repeat(3, 1fr);
        grid-gap: 20px;
        &_item {
          width: 100%;
          height: 200px;
          border-radius: 20px 20px 20px 20px;
          background: #3C6AFD;
          padding: 20px 30px;
          box-sizing: border-box;
          display: flex;
          column-gap: 8px;
          color: #fff;
          font-size: 16px;
          transition: all 0.3s ease;
          img {
            width: 48px;
            height: 48px;
          }
          .sub_title {
            line-height: 48px;
            font-size: 20px;
            font-weight: bold;
          }
        }
        &_item:hover {
          box-shadow: 0 5px 30px rgba($color: #3C6AFD, $alpha: 0.2);
        }
      }
    }
  }
  .industry {
    width: 100%;
    height: 865px;
    background: url('../../assets/image/rjkfyyhy.png');
    background-repeat: no-repeat;
		background-size: 100% auto;
    &_content {
      width: $width;
      margin: 0 auto;
      &_list {
        display: grid;
        grid-template-columns: repeat(4, 1fr);
        grid-gap: 20px;
        &_item {
          width: 100%;
          height: 180px;
          background-repeat: no-repeat;
          overflow: hidden;
          color: #fff;
          font-weight: bold;
          font-size: 20px;
          line-height: 180px;
          text-align: center;
          border-radius: 10px;
        }
        .i1 {
          background: url('../../assets/image/jrhy.png');
        }
        .i2 {
          background: url('../../assets/image/zhyl.png');
        }
        .i3 {
          background: url('../../assets/image/jypx.png');
        }
        .i4 {
          background: url('../../assets/image/zzyls.png');
        }
        .i5 {
          background: url('../../assets/image/shfw.png');
        }
        .i6 {
          background: url('../../assets/image/nywl.png');
        }
        .i7 {
          background: url('../../assets/image/zfyggbm.png');
        }
        .i8 {
          background: url('../../assets/image/fdc.png');
        }
        .i9 {
          background: url('../../assets/image/qybg.png');
        }
        .i10 {
          background: url('../../assets/image/sjzb.png');
        }
        .i11 {
          background: url('../../assets/image/ly.png');
        }
        .i12 {
          background: url('../../assets/image/zhcs.png');
        }
        .i1,.i2,.i3,.i4,.i5,.i6,.i7,.i8,.i9,.i10,.i11,.i12 { 
          background-size: 100% auto;
          background-position: center;
          transition: background-size 0.5s ease;
        }
        &_item:hover {
          background-size: 120% auto;
        }
      }
    }
  }
}
</style>
